import script from "./CoreUiChatHistorySuggestedAnswer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoreUiChatHistorySuggestedAnswer.vue?vue&type=script&setup=true&lang=ts"

import "./CoreUiChatHistorySuggestedAnswer.vue?vue&type=style&index=0&id=3e335170&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e335170"]])

export default __exports__